module.exports = __webpack_public_path__ + "static/media/reserves_white.4949df19.svg";